export const errorAction = (type, error, source) => {
	let payload;

	if (error && (error.status || (error.response && error.response.status))) {
		payload = {
			action: source && source.type,
			source,
			status: error.status || error.response.status,
			statusText: error.statusText || error.response.statusText,
			data: error.data,
			error
		};
	} else {
		payload = {
			action: source && source.type,
			source,
			data: error && error.message,
			error
		};
	}

	if (payload.data && payload.data === 'Network Error') {
		// we don't want to have to make the network error message for each page so just make a
		// generic action for the error page to map an error to
		payload.data = '';
		// RDPP-567 remove logging the whole error for network errors in production
		if (!window.$conf.devMode) {
			payload.error = {};
		}
		payload.action = 'NETWORK_ERROR';
	}

	return { type, payload };
};

/**
 * Creates actions
 * @param {string[]} actions - Actions to create.
 * @returns {object} An object of actions.
 * @example createActionTypes([ 'FETCH_FOO' ]);
 */
export const createActionTypes = (actions) => {
	return actions.reduce((acc, cur) => {
		acc[cur] = cur;
		return acc;
	}, {});
};
